/*
 * Dummy CMID used exclusively for demo mode.
 * This is not a real organisation — it exists only to
 * trigger the demo mode URL interceptor.
 */
export const demoOrganizationCmId = '901234567';
